
export enum Unit {
    VIAGENS,
    KT,
    T,
    KTON,
    TON,
    KG
}